/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import _ from 'underscore';

import FolderSelectorModal from 'file-browser/FolderSelectorModal';
import RegistryActions from 'registry/RegistryActions';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as ShortcutUtil from 'util/ShortcutUtil';

interface Props {
  className?: string;
  disabled?: boolean;
  files: Array<any>;
  finderId: string;
  initialSelectedFolderId?: string;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
}

class UnregisterButton extends React.Component<Props> {
  private handleOpenForUnregister = (): void => {
    this.props.onClickTracking?.();
    FolderSelectorModal.openForUnregister(
      {
        initialSelectedFolderId: this.props.initialSelectedFolderId,
        itemsToMove: this.props.files,
        showInventory: true, // Registered files are always inventory items
        showNotebook: false,
      },
      (folderId) => {
        const parentFolderIds = ShortcutUtil.getParentFolderIdsWithShortcuts(
          this.props.files,
          this.props.finderId
        );
        // eslint-disable-next-line no-restricted-syntax
        const selectedIds = _.pluck(this.props.files, 'id');
        RegistryActions.unregisterWithDataMods(selectedIds, folderId, parentFolderIds);
      }
    );
  };

  override render(): JSX.Element {
    return (
      <Tooltip container="body" placement={TooltipPlacement.TOP} title="Unregister">
        <Button
          aria-label="Unregister"
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          className={this.props.className}
          disabled={this.props.disabled}
          icon="unregister"
          onClick={this.handleOpenForUnregister}
          size={ButtonSize.SMALL}
        />
      </Tooltip>
    );
  }
}

export default UnregisterButton;
